import axios from 'axios'
import qs from 'qs'
// 取消重复请求的class
class CancelRequest {
    constructor() {
        if (!CancelRequest.instance) {
            this.pendingRequest = new Map(); // 请求列表
            CancelRequest.instance = this
        }
        return CancelRequest.instance
    }

    // 用于根据当前请求的信息，生成请求 Key；
    generateReqKey(config) {
        const { method, url, params, data } = config;
        return [method, url, qs.stringify(params), qs.stringify(data)].join("&");
    }

    // 检查是否存在重复请求，若存在则取消已发的请求。
    isRepeatRequest(config) {
        const requestKey = this.generateReqKey(config);
        if (this.pendingRequest.has(requestKey)) {
            const cancelToken = this.pendingRequest.get(requestKey);
            cancelToken(requestKey);
            this.pendingRequest.delete(requestKey);
        } else {
            // 添加请求到pendding中
            config.cancelToken = config.cancelToken || new axios.CancelToken((cancel) => {
                this.pendingRequest.set(requestKey, cancel);
            });
        }
    }

    // 删除某个请求
    removePendingRequest(config) {
        const requestKey = this.generateReqKey(config);
        this.pendingRequest.has(requestKey) && this.pendingRequest.delete(requestKey)
    }

    // 清空所有请求
    removeAllPendingRequest() {
        this.pendingRequest.clear(); // 清空请求列表
    }


}

export default CancelRequest